export default "__VITE_ASSET__73c43d98__"